export const themeOptions = [
    { text: 'Строительство скважин/бурение', value: 'Строительство скважин/бурение' },
    { text: 'Геология, геофизика', value: 'Геология, геофизика' },
    {
        text: 'Разработка и добыча углеводородов, включая ППД, МУН и интенсификацию притока',
        value: 'Разработка и добыча углеводородов, включая ППД, МУН и интенсификацию притока',
    },
    {
        text: 'Обустройство месторождения, системы автоматизации производственного процесс',
        value: 'Обустройство месторождения, системы автоматизации производственного процесс',
    },
    {
        text: 'Подготовка, транспортировка, хранение, переработка углеводородов',
        value: 'Подготовка, транспортировка, хранение, переработка углеводородов',
    },
    {
        text: 'Технологии защиты нефтепромыслового, внутрискважинного оборудования и трубопроводных систем',
        value: 'Технологии защиты нефтепромыслового, внутрискважинного оборудования и трубопроводных систем',
    },
    { text: 'Энергосберегающее оборудование и технологии', value: 'Энергосберегающее оборудование и технологии' },
    {
        text: 'Цифровизация, ИскИн, новые производственные и информационные технологии',
        value: 'Цифровизация, ИскИн, новые производственные и информационные технологии',
    },
    { text: 'Лабораторные исследования', value: 'Лабораторные исследования' },
];

export const directionsOptions = [
    { text: 'Цифра', value: 'Цифра' },
    { text: 'Технологии', value: 'Технологии' },
    { text: 'Стратегии', value: 'Стратегии' },
    { text: 'Люди', value: 'Люди' },
];

export const typeOptions = [
    { text: 'Продукт', value: 'Продукт' },
    { text: 'Технология', value: 'Технология' },
];

export const stageMap: Record<string, { text: string; value: string }[]> = {
    Продукт: [
        { text: 'Прототип готовый к ОПИ', value: 'Прототип готовый к ОПИ' },
        { text: 'Промышленный образец после ОПИ', value: 'Промышленный образец после ОПИ' },
        { text: 'Серийное производство', value: 'Серийное производство' },
    ],
    Технология: [
        { text: 'Проведены ОПИ', value: 'Проведены ОПИ' },
        { text: 'Реализуемая технология', value: 'Реализуемая технология' },
    ],
};

export const TECHNOLOGICAL_MATURITY_TRL_6_9 = 'TRL 6–9';

export const technologicalMaturityMap: Record<string, { text: string; value: string }[]> = {
    Продукт: [
        {
            text: 'TRL 1–3 — научно-исследовательские работы (формулирование концепции, проверка осуществимости)',
            value: 'TRL 1–3',
        },
        {
            text: 'TRL 4–5 — опытно-конструкторские работы (лабораторные испытания, прототип)',
            value: 'TRL 4–5',
        },
        {
            text: 'TRL 6–9 — внедрение (демонстрация в близких к реальным условиях или в реальных условиях, успешная эксплуатация)',
            value: TECHNOLOGICAL_MATURITY_TRL_6_9,
        },
    ],
};

export const themeTrackOptions = [
    {
        text: 'Производственные технологии и оборудование для бурения и добычи',
        value: 'Производственные технологии и оборудование для бурения и добычи',
    },
    { text: 'Обустройство месторождений', value: 'Обустройство месторождений' },
    { text: 'Цифровые решения', value: 'Цифровые решения' },
    {
        text: 'Переработка углеводородов, нефтехимия и новые материалы',
        value: 'Переработка углеводородов, нефтехимия и новые материалы',
    },
    {
        text: 'Промышленная безопасность, охрана труда и окружающая среда',
        value: 'Промышленная безопасность, охрана труда и окружающая среда',
    },
];

export const technologicalMaturityOptions = Object.values(technologicalMaturityMap).flat();
